import "./style.scss";

import { FC, ReactNode, useEffect, useState } from "react";
import { singlePagesConst } from "@/src/constants/single-pages";
import AdmissionProcess from "../AdmissionProcess/AdmissionProcess";
import { Link } from "react-router-dom";
import RedLineForTitle from "../RedLineForTitle/RedLineForTitle";

interface ISinglePage {
  pageId?: string;
}
interface ICurrentObj {
  path: string;
  title: string;
  contentJSX: ReactNode;
  contentSearch: string;
}

const SingleProgramsPage: FC<ISinglePage> = ({ pageId }) => {
  const [currentObj, setCurrentObj] = useState<ICurrentObj | null>(null);
  console.log(pageId, "pageId");
  useEffect(() => {
    if (pageId) {
      const matchedPage = singlePagesConst.find((page) => {
        const cleanedPath = page.path.replace(/^\/single-programs\//, "").replace(/^\//, "");
        return cleanedPath === pageId;
      });

      if (matchedPage) {
        setCurrentObj(matchedPage);
      }
    }
  }, [pageId]);

  return currentObj ? (
    <div className="single-programs container padding-top">
      <RedLineForTitle title={currentObj.title} />

      {/* <div className="single-programs-title">
        <h1>{currentObj.title}</h1>
      </div> */}
      <div className="single-programs-content">{currentObj.contentJSX}</div>
      <AdmissionProcess />
      <Link to={"/apply-online"} className="btn-default reverse">
        Узнать цену и программу
      </Link>
    </div>
  ) : null;
};

export default SingleProgramsPage;
